<template>
  <div>
    <div :id="namespacePlv">
      <b-col cols="12">
        <h2 :class="showDetails.plv ? 'rotate active' : 'no-rotate'">
          PLV
          <i
            class="fas fa-chevron-left"
            @click="togglePlv"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.plv"
        :id="'liste_stats_' + namespacePlv"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTablePlv"
          :name="namespacePlv"
          :actions="getActions(namespacePlv)"
          :colonnes="colsPlv"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.plv"
          verbose-namespace="PLV"
          @row-click="openDetails($event, namespacePlv, 'stock', 'PLV')"
          @action-callback="
            dispatchAction(
              $event,
              refGenericTablePlv,
              namespacePlv,
              'stock',
              'PLV'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespaceOuvrages">
      <b-col cols="12">
        <h2 :class="showDetails.ouvrages ? 'rotate active' : 'no-rotate'">
          Ouvrages
          <i
            class="fas fa-chevron-left"
            @click="toggleOuvrages"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.ouvrages"
        :id="'liste_stats_' + namespaceOuvrages"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableOuvrages"
          :name="namespaceOuvrages"
          :actions="getActions(namespaceOuvrages)"
          :colonnes="colsOuvrages"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.ouvrages"
          verbose-namespace="Ouvrages"
          @row-click="openDetails($event, namespaceOuvrages, 'stock', 'ouvrage')"
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableOuvrages,
              namespaceOuvrages,
              'stock',
              'ouvrage'
            )
          "
        />
      </b-col>
    </div>

    <StatsModal :generic-table-namespace="namespaceTab" />
  </div>
</template>

<script>
import MixinStats from "@/mixins/mixinStats";

export default {
  name: "ListeStatsStocks",
  mixins: [MixinStats],
  data() {
    return {
      refGenericTablePlv: "tabPlvStock",
      refGenericTableOuvrages: "tabOuvragesStock",

      namespacePlv: "plv",
      namespaceOuvrages: "ouvrages",

      showDetails: {
        plv: false,
        ouvrages: false,
      },

      extraFilters: {
        plv: {
          type: "stock",
          sous_type: "PLV",
        },
        ouvrages: {
          type: "stock",
          sous_type: "ouvrage",
        },
      },

      colsPlv: [
        { key: "date_creation", overrideName: "Créée le", defaultOder: true },
        { key: "user_created__username", overrideName: "Créée par" },
        { key: "nom" },
      ],
      colsOuvrages: [
        { key: "date_creation", overrideName: "Créée le", defaultOder: true },
        { key: "user_created__username", overrideName: "Créée par" },
        { key: "nom" },
        {
          key: "filtres__catalogue",
          overrideName: "Catalogues",
          noOrder: true,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit(
      `${this.namespaceOuvrages}/setFormatDataFunction`,
      this.verboseColsStockForTable,
    );
  },
  methods: {
    /**
     * Affiche/masque le tableau des PLV et définit le namespace du tableau de recherche.
     * @public
     */
    togglePlv() {
      this.showDetails.plv = !this.showDetails.plv;
      this.$store.commit("setNamespaceSearch", 0);
    },
    /**
     * Affiche/masque le tableau des PLV et définit le namespace du tableau de recherche.
     * @public
     */
    toggleOuvrages() {
      this.showDetails.ouvrages = !this.showDetails.ouvrages;
      this.$store.commit("setNamespaceSearch", 1);
    },
    /**
     * Met en forme les données du tableau des ouvrages.
     * @public
     * @param {Object} data Données du tableau.
     */
    verboseColsStockForTable(data) {
      const { results } = data;

      results.forEach((ligne) => {
        if (ligne.filtres) {
          if (
            ligne.filtres.categorie_general
            && ligne.filtres.categorie_jeunesse
          ) {
            ligne.filtres__catalogue_verbose = "Général et jeunesse";
          } else if (ligne.filtres.categorie_general) {
            ligne.filtres__catalogue_verbose = "Général";
          } else if (ligne.filtres.categorie_jeunesse) {
            ligne.filtres__catalogue_verbose = "Jeunesse";
          } else {
            ligne.filtres__catalogue_verbose = "";
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/style/_stats.scss";
</style>
